import { Repository } from '@jbt/utils';

export class ReducersRepository extends Repository<any> {

    constructor() {

        super({
            id: 'ReducersRepository',
            fallbackKey: 'default'
        });

        this.addByMap({
            default: state => state
        });
    }
}
